import { Add, Delete } from '@mui/icons-material';
import { Box, Button, Divider, IconButton, Typography } from '@mui/material';
import { Operation } from 'src/types/operation';

import { QuotaRow } from './QuotaRow';
import { QuotaRecord } from '../AddFundsToWallet';

type OperationWithRecords = Operation & { quotas: QuotaRecord[] };

type FundItemProps = {
  fund: OperationWithRecords;
  fundIndex: number;
  onRemoveFund: (hashId: string) => void;
  onAddRecord: (hashId: string) => void;
  onRemoveRecord: (hashId: string, quota: string, series: string) => void;
  onChangeRecord: (
    hashId: string,
    recordIndex: number,
    field: keyof QuotaRecord,
    value: string | number,
  ) => void;
};

export function FundItem({
  fund,
  fundIndex,
  onRemoveFund,
  onAddRecord,
  onRemoveRecord,
  onChangeRecord,
}: FundItemProps) {
  return (
    <Box
      sx={{
        mt: 2,
        mb: 2,
        border: '1px solid #eee',
        borderRadius: 2,
        p: 2,
      }}>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography variant="subtitle1" fontWeight={600}>
          {fund.name}
        </Typography>
        <IconButton
          onClick={() => onRemoveFund(fund.hashId)}
          size="small"
          color="error">
          <Delete />
        </IconButton>
      </Box>
      <Divider sx={{ mt: 1, mb: 2 }} />
      {fund.quotas.map((record, recordIndex) => (
        <>
          <QuotaRow
            key={`${fund.hashId}-${recordIndex}`}
            fund={fund}
            fundIndex={fundIndex}
            recordIndex={recordIndex}
            onRemove={() =>
              onRemoveRecord(fund.hashId, record.class, record.series)
            }
            onChange={(field, value) =>
              onChangeRecord(fund.hashId, recordIndex, field, value)
            }
            canRemove={fund.quotas.length > 1}
          />
          <Divider sx={{ my: 2 }} />
        </>
      ))}
      <Button
        variant="outlined"
        startIcon={<Add />}
        onClick={() => onAddRecord(fund.hashId)}
        sx={{ mt: 1 }}>
        Adicionar cota
      </Button>
    </Box>
  );
}
